import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { AuthenticationService } from '../authentication/authentication.service';
import { HandlePermissions } from 'src/app/shared/utils/permissions';
import { RequestsPermissions } from 'src/app/shared/model/requestType.enum';
import { StorageService } from '../storage/storage.service';
import { Collective } from 'src/app/shared/model/user.model';

@Injectable({
  providedIn: 'root'
})
export class IsNotAuthorizedGuard {
  constructor(
    private router: Router,
    private authorization: AuthenticationService,
    private permissions: HandlePermissions,
    private storageService: StorageService
  ) {}

  setPermission(url: string): boolean {
    let result = true;
    const urlUppercase = url.toUpperCase();
    Object.keys(RequestsPermissions).some((key) => {
      const permissionValue =
        RequestsPermissions[key as keyof typeof RequestsPermissions];
      return permissionValue === urlUppercase
        ? (result = true)
        : (result = false);
    });
    return result;
  }

  canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
    const url = route.url[0]?.path ?? '';
    const existUrl = this.setPermission(url);
    const user = this.storageService.get('config');

    if (url === 'authorizations') {
      this.storageService.set('redirect_url', url);
    } else {
      this.storageService.removeItem('redirect_url');
    }

    if (!this.authorization.isAuthorized()) {
      return this.router.parseUrl('/login');
    }

    if (user?.groupType === Collective.EXTERNVO) {
      if (user?.privacyPolicyAccepted === false) {
        return url === 'manage-data'
          ? true
          : this.router.parseUrl('/manage-data');
      }
      const externVoAllowedRoutes = ['vo', 'manage-data', 'extern-vo'];

      return externVoAllowedRoutes.includes(url)
        ? true
        : this.router.parseUrl('/vo');
    }

    if (url === 'extern-vo') {
      return this.checkPermission('COMPANY_ADMINVO');
    }

    if (existUrl || url === 'loan') {
      return this.checkPermission(url.toUpperCase());
    }

    return true;
  }

  checkPermission(orderType: string): boolean | UrlTree {
    const hasPermission = this.permissions.getPermission(
      orderType.toUpperCase()
    );
    return hasPermission ? true : this.router.parseUrl('/landing');
  }
}
